import dayjs from "dayjs";
import { ValidationResult } from "../validationResult.class";
import { Project } from "./project.class";

export class PostPutProject {
    id: number | undefined;
    name: string;
    number: string;
    description: string;
    startDate: string; // Date UTC (datetime verzonden);
    contractorId: number | undefined;

    constructor(p?: Project) {
        this.id = p?.id ?? undefined;
        this.name = p?.name ?? '';
        this.number = p?.number ?? '';
        this.description = p?.description ?? '';
        this.startDate = p?.startDate ?? dayjs().format('DD/MM/YYYY');
        this.contractorId = p?.contractorId ?? undefined;
    }

    validate(apiMethod: 'POST' | 'PUT'): ValidationResult {
        const result = new ValidationResult();

        if (apiMethod === 'PUT' && this.id === undefined) {
            result.addError({ message: 'Project heeft geen ID, de wijzigingen kunnen niet opgeslagen worden.'});
        } 
        
        if (!this.name || this.name.length === 0) {
            result.addError({ message: 'Projectnaam is een vereiste.' });
        }
        
        if (!this.number || this.number.toString().length === 0) {
            result.addError({ message: 'Projectnummer is een vereiste.' });
        }

        if (!this.startDate) {
            result.addError({ message: 'Startdatum project is een vereiste.' });
        }

        if (!this.contractorId) {
            result.addError({ message: 'Er moet een aannemer geselecteerd worden.' });
        }

        return result;
    }
}
